import { IFilterItemV2 } from "#src/commonV2/Table/Filter/types";
import { PaymentStatusValue } from "#src/config/filter/workspace/value";
import i18next from "i18next";
import { PaymentStatusEnum } from "./enum";

export const paymentStatusItems: IFilterItemV2[] = [
  {
    key: PaymentStatusEnum.PAID,
    value: PaymentStatusValue.PAID,
    getLabel: () => i18next.t("filter.paymentStatus.paid"),
  },
  {
    key: PaymentStatusEnum.PROCESSING,
    value: PaymentStatusValue.PROCESSING,
    getLabel: () => i18next.t("filter.paymentStatus.processing"),
  },
];
